(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skin-type-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(root) {
    var sliderEl = root.querySelector('[data-srs-slider]');
    if (!sliderEl) return;
    var track = sliderEl.querySelector('[data-srs-track]');
    if (!track) return;

    var realSlides = Array.prototype.slice.call(track.querySelectorAll('[data-srs-slide]:not([data-clone])'));
    var prev = sliderEl.querySelector('[data-srs-prev]');
    var next = sliderEl.querySelector('[data-srs-next]');
    var dotsWrap = sliderEl.querySelector('[data-srs-dots]');
    var realCount = realSlides.length;
    if (realCount === 0) return;

    var loop = sliderEl.getAttribute('data-loop') === 'true' && realCount > 1;
    var CLONES = loop ? Math.min(realCount, 3) : 0;

    // Build clones for infinite loop
    if (loop) {
      // append clones of first CLONES slides (to the end)
      for (var a = 0; a < CLONES; a++) {
        var cEnd = realSlides[a].cloneNode(true);
        cEnd.setAttribute('data-clone', 'end');
        track.appendChild(cEnd);
      }
      // prepend clones of last CLONES slides (to the start, in order)
      for (var b = 0; b < CLONES; b++) {
        var srcIndex = realCount - CLONES + b;
        var cStart = realSlides[srcIndex].cloneNode(true);
        cStart.setAttribute('data-clone', 'start');
        track.insertBefore(cStart, track.querySelector('[data-srs-slide]'));
      }
    }

    var allSlides = Array.prototype.slice.call(track.querySelectorAll('[data-srs-slide]'));

    // Dots map to REAL slides only
    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      realSlides.forEach(function (s, i) {
        var d = document.createElement('button');
        d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        d.addEventListener('click', function () { goToReal(i); });
        dotsWrap.appendChild(d);
        dots.push(d);
      });
    }

    function centerOf(el) {
      var r = el.getBoundingClientRect();
      return r.left + r.width / 2;
    }

    function slideCenterTarget(el) {
      return el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2;
    }

    function nearestIndex() {
      var tc = centerOf(track);
      var closest = 0, min = Infinity;
      allSlides.forEach(function (s, i) {
        var d = Math.abs(centerOf(s) - tc);
        if (d < min) { min = d; closest = i; }
      });
      return closest;
    }

    function realIndexOf(allIndex) {
      // map an index in allSlides back to a real slide index 0..realCount-1
      return ((allIndex - CLONES) % realCount + realCount) % realCount;
    }

    function update() {
      var idx = nearestIndex();
      allSlides.forEach(function (s, i) { s.classList.toggle('is-center', i === idx); });
      var ri = realIndexOf(idx);
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === ri); });
    }

    function scrollToIndex(i, smooth) {
      var s = allSlides[i];
      if (!s) return;
      track.scrollTo({ left: slideCenterTarget(s), behavior: smooth ? 'smooth' : 'auto' });
    }

    function goToReal(realI, smooth) {
      scrollToIndex(CLONES + realI, smooth !== false);
    }

    // Infinite jump handling: when we settle on a clone, jump to its real twin (no animation)
    var jumpTimer = null;
    function maybeLoopJump() {
      if (!loop) return;
      if (isDown) return; // don't reposition mid-drag (caused the centering glitch)
      var idx = nearestIndex();
      if (idx < CLONES) {
        // in start-clones -> jump forward by realCount
        scrollToIndex(idx + realCount, false);
      } else if (idx >= CLONES + realCount) {
        // in end-clones -> jump back by realCount
        scrollToIndex(idx - realCount, false);
      }
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () { update(); ticking = false; });
        ticking = true;
      }
      if (jumpTimer) clearTimeout(jumpTimer);
      jumpTimer = setTimeout(maybeLoopJump, 90);
    });

    function step(dir) {
      var idx = nearestIndex();
      var target = idx + dir;
      if (!loop) {
        target = Math.max(0, Math.min(allSlides.length - 1, target));
      }
      scrollToIndex(target, true);
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    // ---------------- Pointer drag (mouse + touch) ----------------
    var isDown = false, dragMoved = false, startX = 0, startScroll = 0, pointerId = null;

    function onPointerDown(e) {
      // ignore right-click; allow primary button / touch / pen
      if (e.button !== undefined && e.button !== 0) return;
      isDown = true;
      dragMoved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      pointerId = e.pointerId;
      sliderEl.classList.add('is-dragging');
      stopAutoplay();
      // NOTE: pointer capture is intentionally NOT set here. Capturing on
      // every pointerdown (even a plain click with no movement) causes the
      // browser to redirect the subsequent click event to `track` instead of
      // the slide's <a> tag, which silently kills native link navigation on
      // desktop. Capture is only acquired once real dragging is detected,
      // in onPointerMove below.
    }
    function onPointerMove(e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) {
        if (!dragMoved && track.setPointerCapture && pointerId != null) {
          try { track.setPointerCapture(pointerId); } catch (err) {}
        }
        dragMoved = true;
      }
      track.scrollLeft = startScroll - dx;
    }
    function onPointerUp() {
      if (!isDown) return;
      isDown = false;
      sliderEl.classList.remove('is-dragging');
      if (track.releasePointerCapture && pointerId != null) {
        try { track.releasePointerCapture(pointerId); } catch (err) {}
      }
      // snap to whatever is nearest now, smoothly
      var idx = nearestIndex();
      scrollToIndex(idx, true);
      maybeRestartAutoplay();
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerUp);
    track.addEventListener('pointerleave', onPointerUp);
    // prevent click navigation right after a drag
    track.addEventListener('click', function (e) {
      if (dragMoved) { e.preventDefault(); e.stopPropagation(); dragMoved = false; }
    }, true);
    // stop native image drag ghost
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // ---------------- Autoplay ----------------
    var autoplay = sliderEl.getAttribute('data-autoplay') === 'true' && realCount > 1;
    var autoplayMs = (parseFloat(sliderEl.getAttribute('data-autoplay-speed')) || 4) * 1000;
    var autoplayTimer = null;

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        if (document.hidden) return;
        step(1);
      }, autoplayMs);
    }
    function stopAutoplay() {
      if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
    }
    var restartTimer = null;
    function maybeRestartAutoplay() {
      if (!autoplay) return;
      if (restartTimer) clearTimeout(restartTimer);
      restartTimer = setTimeout(startAutoplay, 1200);
    }

    // pause on hover (desktop) / resume on leave
    sliderEl.addEventListener('mouseenter', stopAutoplay);
    sliderEl.addEventListener('mouseleave', startAutoplay);
    // pause briefly on manual nav, then resume
    if (prev) prev.addEventListener('click', function () { stopAutoplay(); maybeRestartAutoplay(); });
    if (next) next.addEventListener('click', function () { stopAutoplay(); maybeRestartAutoplay(); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay(); else startAutoplay();
    });

    window.addEventListener('resize', function () {
      // keep centered on the current real slide after resize
      var ri = realIndexOf(nearestIndex());
      goToReal(ri, false);
      update();
    });

    // Initial position
    requestAnimationFrame(function () {
      if (loop) {
        goToReal(0, false);
      } else {
        scrollToIndex(Math.floor(realCount / 2), false);
      }
      update();
      startAutoplay();
    });
  }

  // ---------------- Random auto-flip (desktop + mobile) ----------------
  // Periodically flips a random card so users learn the cards are interactive.
  // Runs independently of hover: hovering reveals a card, but this keeps going.
  function initFlips(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-srs-card]'));
    if (!cards.length) return;

    var FLIP_MIN_GAP = 2200;   // ms — shortest wait between flips
    var FLIP_MAX_GAP = 4200;   // ms — longest wait between flips
    var FLIP_HOLD = 1600;      // ms — how long a card stays flipped
    var lastIndex = -1;

    function randGap() {
      return FLIP_MIN_GAP + Math.random() * (FLIP_MAX_GAP - FLIP_MIN_GAP);
    }

    function pickCard() {
      if (cards.length === 1) return cards[0];
      var idx, tries = 0;
      do {
        idx = Math.floor(Math.random() * cards.length);
        tries++;
      } while ((idx === lastIndex || cards[idx].matches(':hover')) && tries < 8);
      lastIndex = idx;
      return cards[idx];
    }

    function scheduleFlip() {
      setTimeout(function () {
        if (!document.hidden) {
          var card = pickCard();
          // skip if hovered (user is already revealing it) — try again next tick
          if (card && !card.matches(':hover')) {
            card.classList.add('is-flipped');
            setTimeout(function () {
              card.classList.remove('is-flipped');
            }, FLIP_HOLD);
          }
        }
        scheduleFlip();
      }, randGap());
    }

    scheduleFlip();
  }

  function initShowcase(root) {
    initSlider(root);
    initFlips(root);
  }

  document.querySelectorAll('[data-testid="skin-ritual-showcase"]').forEach(initShowcase);

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-testid="skin-ritual-showcase"]');
    if (el) initShowcase(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soap-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Recycling marquee. Liquid renders only the ORIGINAL N images — no
  // duplicated array in the markup. But the recycle-to-end technique only
  // looks seamless if there's ALWAYS enough total content width to fill more
  // than the visible container — otherwise a "recycled" image is still
  // inside the visible area when it moves, and just pops into place instead
  // of sliding in from off-screen.
  //
  // So at runtime, JS measures the actual container width and clones (not
  // duplicates via Liquid — clones via JS, reusing the same cached <img>
  // elements) just enough extra copies of the original set to guarantee the
  // track is always wider than 2x the visible area. This happens ONCE at
  // init (a single DOM mutation, not a repeating one).
  //
  // Recycling itself does NOT move DOM nodes (that used to force the
  // browser to fully repaint the whole `will-change: transform` composited
  // layer every time, causing a small periodic stutter). Instead, each item
  // gets a CSS `order` value, and recycling just bumps that value higher —
  // a pure style change that reflows within the existing layer instead of
  // invalidating it.
  function initReel(root) {
    var track = root.querySelector('[data-testid="acne-showcase-reel-track"]');
    if (!track) return;

    var originalItems = Array.prototype.slice.call(track.children);
    if (originalItems.length < 2) return; // nothing meaningful to loop

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return; // CSS fallback already makes .acne-showcase__reel scrollable

    var durationSeconds = parseFloat(track.getAttribute('data-reel-speed')) || 40;
    var offset = 0; // current translateX, always <= 0
    var lastTime = null;
    var pxPerSecond = null;
    var rafId = null;
    var paused = false;
    var maxOrder = 0;
    var headPos = 0; // index into `items` of the currently left-most element

    function currentGap() {
      var style = getComputedStyle(track);
      return parseFloat(style.columnGap || style.gap) || 0;
    }

    function originalSetWidth() {
      var gap = currentGap();
      var width = 0;
      for (var i = 0; i < originalItems.length; i++) {
        width += originalItems[i].getBoundingClientRect().width;
      }
      width += gap * (originalItems.length - 1 || 0);
      return width;
    }

    function totalItemsWidth(list) {
      var gap = currentGap();
      var width = 0;
      for (var i = 0; i < list.length; i++) {
        width += list[i].getBoundingClientRect().width;
      }
      width += gap * (list.length - 1 || 0);
      return width;
    }

    // `items` is the full working set (originals + any clones added below),
    // always in a fixed left-to-right visual order via CSS `order`, cycled
    // via the `headPos` pointer rather than by moving DOM nodes.
    var items = originalItems.slice();

    function ensureEnoughContent() {
      var containerWidth = root.getBoundingClientRect().width;
      var safetyLimit = 12; // hard cap so a measurement glitch can't loop forever
      var loops = 0;
      var addedAny = false;
      while (totalItemsWidth(items) < containerWidth * 2 && loops < safetyLimit) {
        for (var i = 0; i < originalItems.length; i++) {
          var clone = originalItems[i].cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
          maxOrder += 1;
          clone.style.order = maxOrder;
          items.push(clone);
          addedAny = true;
        }
        loops++;
      }
      return addedAny;
    }

    // Initial order assignment for the original set only happens once, before
    // any clones or recycling exist — subsequent calls to ensureEnoughContent
    // (e.g. on resize) only assign `order` to brand-new clones, never resetting
    // items that are already mid-animation.
    for (var initI = 0; initI < items.length; initI++) {
      items[initI].style.order = initI;
    }
    maxOrder = items.length - 1;

    function recalcSpeed() {
      // Speed is defined relative to one pass of the ORIGINAL (unique) set's
      // width, so the "Auto-scroll speed" setting means the same thing
      // regardless of how many safety clones got added to fill the viewport.
      pxPerSecond = originalSetWidth() / durationSeconds;
    }

    function step(timestamp) {
      if (paused) {
        lastTime = null;
        rafId = requestAnimationFrame(step);
        return;
      }
      if (lastTime === null) lastTime = timestamp;
      var deltaSeconds = (timestamp - lastTime) / 1000;
      lastTime = timestamp;

      if (pxPerSecond === null) recalcSpeed();

      offset -= pxPerSecond * deltaSeconds;

      // Seamless wrap: once we've scrolled a full original-set-width, snap
      // offset back by exactly that width. The cloned content repeats
      // identically every originalWidth px, so this is visually undetectable —
      // and unlike the old `order` bump, only `transform` changes here, so
      // it's a pure compositor op with no layout/reflow, and no more glitch.
      var originalWidth = originalSetWidth();
      if (-offset >= originalWidth) {
        offset += originalWidth;
      }

      track.style.transform = 'translateX(' + offset + 'px)';
      rafId = requestAnimationFrame(step);
    }

    // Pause on hover/focus for accessibility and easier browsing, resume on leave
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });

    // Re-check on resize: recompute speed, and top up content if the
    // container grew wide enough to outrun the current cloned width.
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      pxPerSecond = null;
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(ensureEnoughContent, 150);
    });

    ensureEnoughContent();
    rafId = requestAnimationFrame(step);

    // Cleanup hook for theme editor re-renders
    root._acneReelCleanup = function () {
      if (rafId) cancelAnimationFrame(rafId);
    };
  }

  function initAll(context) {
    (context || document).querySelectorAll('[data-testid="acne-showcase-reel"]').forEach(initReel);
  }

  initAll(document);

  // Theme editor support: re-init when this section reloads
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(root) {
    var sliderEl = root.querySelector('[data-srs-slider]');
    if (!sliderEl) return;
    var track = sliderEl.querySelector('[data-srs-track]');
    if (!track) return;

    var realSlides = Array.prototype.slice.call(track.querySelectorAll('[data-srs-slide]:not([data-clone])'));
    var prev = sliderEl.querySelector('[data-srs-prev]');
    var next = sliderEl.querySelector('[data-srs-next]');
    var dotsWrap = sliderEl.querySelector('[data-srs-dots]');
    var realCount = realSlides.length;
    if (realCount === 0) return;

    var loop = sliderEl.getAttribute('data-loop') === 'true' && realCount > 1;
    var CLONES = loop ? Math.min(realCount, 3) : 0;

    // Build clones for infinite loop
    if (loop) {
      // append clones of first CLONES slides (to the end)
      for (var a = 0; a < CLONES; a++) {
        var cEnd = realSlides[a].cloneNode(true);
        cEnd.setAttribute('data-clone', 'end');
        track.appendChild(cEnd);
      }
      // prepend clones of last CLONES slides (to the start, in order)
      for (var b = 0; b < CLONES; b++) {
        var srcIndex = realCount - CLONES + b;
        var cStart = realSlides[srcIndex].cloneNode(true);
        cStart.setAttribute('data-clone', 'start');
        track.insertBefore(cStart, track.querySelector('[data-srs-slide]'));
      }
    }

    var allSlides = Array.prototype.slice.call(track.querySelectorAll('[data-srs-slide]'));

    // Dots map to REAL slides only
    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      realSlides.forEach(function (s, i) {
        var d = document.createElement('button');
        d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        d.addEventListener('click', function () { goToReal(i); });
        dotsWrap.appendChild(d);
        dots.push(d);
      });
    }

    function centerOf(el) {
      var r = el.getBoundingClientRect();
      return r.left + r.width / 2;
    }

    function slideCenterTarget(el) {
      return el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2;
    }

    function nearestIndex() {
      var tc = centerOf(track);
      var closest = 0, min = Infinity;
      allSlides.forEach(function (s, i) {
        var d = Math.abs(centerOf(s) - tc);
        if (d < min) { min = d; closest = i; }
      });
      return closest;
    }

    function realIndexOf(allIndex) {
      // map an index in allSlides back to a real slide index 0..realCount-1
      return ((allIndex - CLONES) % realCount + realCount) % realCount;
    }

    function update() {
      var idx = nearestIndex();
      allSlides.forEach(function (s, i) { s.classList.toggle('is-center', i === idx); });
      var ri = realIndexOf(idx);
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === ri); });
    }

    function scrollToIndex(i, smooth) {
      var s = allSlides[i];
      if (!s) return;
      track.scrollTo({ left: slideCenterTarget(s), behavior: smooth ? 'smooth' : 'auto' });
    }

    function goToReal(realI, smooth) {
      scrollToIndex(CLONES + realI, smooth !== false);
    }

    // Infinite jump handling: when we settle on a clone, jump to its real twin (no animation)
    var jumpTimer = null;
    function maybeLoopJump() {
      if (!loop) return;
      if (isDown) return; // don't reposition mid-drag (caused the centering glitch)
      var idx = nearestIndex();
      if (idx < CLONES) {
        // in start-clones -> jump forward by realCount
        scrollToIndex(idx + realCount, false);
      } else if (idx >= CLONES + realCount) {
        // in end-clones -> jump back by realCount
        scrollToIndex(idx - realCount, false);
      }
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () { update(); ticking = false; });
        ticking = true;
      }
      if (jumpTimer) clearTimeout(jumpTimer);
      jumpTimer = setTimeout(maybeLoopJump, 90);
    });

    function step(dir) {
      var idx = nearestIndex();
      var target = idx + dir;
      if (!loop) {
        target = Math.max(0, Math.min(allSlides.length - 1, target));
      }
      scrollToIndex(target, true);
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    // ---------------- Pointer drag (mouse + touch) ----------------
    var isDown = false, dragMoved = false, startX = 0, startScroll = 0, pointerId = null;

    function onPointerDown(e) {
      // ignore right-click; allow primary button / touch / pen
      if (e.button !== undefined && e.button !== 0) return;
      isDown = true;
      dragMoved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      pointerId = e.pointerId;
      sliderEl.classList.add('is-dragging');
      stopAutoplay();
      // NOTE: pointer capture is intentionally NOT set here. Capturing on
      // every pointerdown (even a plain click with no movement) causes the
      // browser to redirect the subsequent click event to `track` instead of
      // the slide's <a> tag, which silently kills native link navigation on
      // desktop. Capture is only acquired once real dragging is detected,
      // in onPointerMove below.
    }
    function onPointerMove(e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) {
        if (!dragMoved && track.setPointerCapture && pointerId != null) {
          try { track.setPointerCapture(pointerId); } catch (err) {}
        }
        dragMoved = true;
      }
      track.scrollLeft = startScroll - dx;
    }
    function onPointerUp() {
      if (!isDown) return;
      isDown = false;
      sliderEl.classList.remove('is-dragging');
      if (track.releasePointerCapture && pointerId != null) {
        try { track.releasePointerCapture(pointerId); } catch (err) {}
      }
      // snap to whatever is nearest now, smoothly
      var idx = nearestIndex();
      scrollToIndex(idx, true);
      maybeRestartAutoplay();
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerUp);
    track.addEventListener('pointerleave', onPointerUp);
    // prevent click navigation right after a drag
    track.addEventListener('click', function (e) {
      if (dragMoved) { e.preventDefault(); e.stopPropagation(); dragMoved = false; }
    }, true);
    // stop native image drag ghost
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // ---------------- Autoplay ----------------
    var autoplay = sliderEl.getAttribute('data-autoplay') === 'true' && realCount > 1;
    var autoplayMs = (parseFloat(sliderEl.getAttribute('data-autoplay-speed')) || 4) * 1000;
    var autoplayTimer = null;

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        if (document.hidden) return;
        step(1);
      }, autoplayMs);
    }
    function stopAutoplay() {
      if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
    }
    var restartTimer = null;
    function maybeRestartAutoplay() {
      if (!autoplay) return;
      if (restartTimer) clearTimeout(restartTimer);
      restartTimer = setTimeout(startAutoplay, 1200);
    }

    // pause on hover (desktop) / resume on leave
    sliderEl.addEventListener('mouseenter', stopAutoplay);
    sliderEl.addEventListener('mouseleave', startAutoplay);
    // pause briefly on manual nav, then resume
    if (prev) prev.addEventListener('click', function () { stopAutoplay(); maybeRestartAutoplay(); });
    if (next) next.addEventListener('click', function () { stopAutoplay(); maybeRestartAutoplay(); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay(); else startAutoplay();
    });

    window.addEventListener('resize', function () {
      // keep centered on the current real slide after resize
      var ri = realIndexOf(nearestIndex());
      goToReal(ri, false);
      update();
    });

    // Initial position
    requestAnimationFrame(function () {
      if (loop) {
        goToReal(0, false);
      } else {
        scrollToIndex(Math.floor(realCount / 2), false);
      }
      update();
      startAutoplay();
    });
  }

  function initShowcase(root) {
    initSlider(root);
  }

  document.querySelectorAll('[data-testid="image-offset-slider"]').forEach(initShowcase);

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-testid="image-offset-slider"]');
    if (el) initShowcase(el);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
